import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/de';

/**
 * Formats a Date in various formats and localizations
 * @param date is any valid date format
 * @param locale is the language/localization to use (en=English, fr=French, de=German)
 * @param toFormat is the selcted format - docs at https://momentjs.com/docs/#/displaying/format/
 * @returns {string}
 */

function dateFormat(date, locale = 'en', toFormat = 'll') {
  let returnDate = '';

  // Validation.  All invalid entries return default empty string
  if (toFormat === '') return returnDate;
  if (locale === '') locale = 'en';
  if (locale.length > 2) locale = locale.substring(0, 2);
  const testDate = moment(date).format(toFormat);

  if (moment(testDate, toFormat, true).isValid()) {
    moment.locale(locale);
    returnDate = moment(date).format(toFormat);
  }
  return returnDate;
}

export default dateFormat;
